import { registerPlugin } from '@capacitor/core';

export interface VendorOrderRingPlugin {
  startRing(options?: { sound?: string; apiUrl?: string; token?: string }): Promise<void>;
  stopRing(): Promise<void>;
  /** Persist logged-in flag for native FCM (SharedPreferences). No-op on web. */
  setSessionActive(options: { active: boolean }): Promise<void>;
  /**
   * Allow the next native ring clip only while unanswered New-tab orders exist.
   * Does not stop the current clip; call stopRing to halt immediately.
   */
  setRingAllowed(options: { allowed: boolean }): Promise<void>;
  isRinging(): Promise<{ ringing: boolean }>;
  configureWatch(options: { apiUrl: string; token: string }): Promise<void>;
  clearWatch(): Promise<void>;
}

/** Native Android order ring (MediaPlayer). No-op on web. */
export const VendorOrderRing = registerPlugin<VendorOrderRingPlugin>('VendorOrderRing', {
  web: () => import('./vendor-order-ring.plugin.web').then((m) => new m.VendorOrderRingWeb()),
});
